import React from 'react';

import { Flex } from '@chakra-ui/react';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { Typography16, Typography17 } from 'uiToolkit/Typography';
import { Button } from 'uiToolkitV1/Button';

import { FunctionSelection } from '../CompetencyByFunctionAndRole';

const CompetencyTableHeader = ({
  tableHeaderRef,
  addNewTag,
  addNew,
  selectedFunction,
  setSelectedFunction,
  setAddNew,
  openCompetencyUploadSidePanel = () => {},
  showUploadButton = true,
}) => (
  <>
    <VerticallyAlignedFlexContainer ref={tableHeaderRef}>
      <Typography16 bottomGutter={1.5}>Competencies by function and role</Typography16>
      <Flex style={{ marginLeft: 'auto' }} gap={2}>
        {showUploadButton && (
          <div>
            <Button w="160px" mr={2} onClick={openCompetencyUploadSidePanel}>
              Upload
            </Button>
          </div>
        )}

        <Button w="160px" mr={2} onClick={addNewTag} isDisabled={addNew}>
          Add Competency
        </Button>
      </Flex>
    </VerticallyAlignedFlexContainer>
    <Typography17 bottomGutter={3}>
      Please input all organization-wide competencies (common across all functions) and specialized competencies
      (applicable to specific functions and roles).
    </Typography17>
    <FunctionSelection
      selectedFunction={selectedFunction}
      setSelectedFunction={setSelectedFunction}
      setAddNew={setAddNew}
    />
  </>
);

export default CompetencyTableHeader;
